import React from 'react'
import TrainersComponent from './components/Trainers'
function Trainers() {
  return (
    <>
      <TrainersComponent/>
    </>
  )
}

export default Trainers